import { Notifier } from '@airbrake/browser';
import { environment } from 'shared/helper/environment';
import { allCacheEntries } from './storage';
export var AUTH_ERROR = 'Request failed with status code 401';
var MAINTENANCE_ERROR = 'Request failed with status code 503';
var filesToIgnore = new RegExp(process.env.AIRBRAKE.filesToIgnore);
var invalidUserAgent = function invalidUserAgent(userAgent) {
  var invalidUserAgents = ['BingPreview/', 'Googlebot/'];
  return !!invalidUserAgents.find(function (invalidUserAgent) {
    return userAgent.indexOf(invalidUserAgent) !== -1;
  });
};
export var skipRequestErrorTracking = function skipRequestErrorTracking(error) {
  var response = error.response || {};
  var skipAirbrake = [401, 503].indexOf(response.status) !== -1 ||
  // Network Error occurs when a user temporarily loses connection, or when XMLHttpRequest.onerror()
  // is triggered
  // Request Aborted occurs when XMLHttpRequest.onaborted() is triggered (happens if a user stops the
  // browser request)
  [AUTH_ERROR, MAINTENANCE_ERROR, 'Network Error', 'Request aborted'].indexOf(error.message) !== -1;
  return skipAirbrake;
};
var errorIsSuppressed = function errorIsSuppressed(_ref) {
  var message = _ref.message;
  var suppressedErrorMessagePatterns = [/.*Synchronous XHR in page dismissal.*/, /timeout of .* exceeded/, /Failed to execute 'send' on 'XMLHttpRequest'/];
  return !!suppressedErrorMessagePatterns.find(function (pattern) {
    return pattern.test(message);
  });
};
var errorMissingFileInformation = function errorMissingFileInformation(_ref2) {
  var backtrace = _ref2.backtrace;
  return !backtrace.find(function (_ref3) {
    var file = _ref3.file;
    return file && /\.js/.test(file);
  });
};
var skipDomain = function skipDomain() {
  var currentUrl = window.location.href.toLowerCase();
  return currentUrl.includes('npgle') || currentUrl.includes('springernature');
};
var skipErrorTracking = function skipErrorTracking(error) {
  return skipRequestErrorTracking(error) || errorIsSuppressed(error) || errorMissingFileInformation(error) || skipDomain();
};
var airbrake = new Notifier(process.env.AIRBRAKE);
if (airbrake) {
  airbrake.addFilter(function (rawNotice) {
    var notice = rawNotice;
    if (invalidUserAgent(notice.context.userAgent)) {
      return null;
    }
    notice.context.environment = environment();
    // notice.context.user = {
    //     ...(window.AppData.airbrakeUser || {}),
    //     fullStorySessionURL: window.fullStorySessionUrl || null,
    //     cache: allCacheEntries(),
    // };

    // There are some errors internal to request helper that we can: a) do nothing about, b) handle in other ways
    // In both of those instances, we don't want those errors to be logged
    var shouldSkipErrorTracking = !!notice.errors.find(function (error) {
      return skipErrorTracking(error);
    });
    if (shouldSkipErrorTracking) {
      return null;
    }

    // If we encounter legacy-shims in the backtrace, let's not report this one
    var errorIsIgnorable = notice.errors.find(function (error) {
      return error.backtrace.find(function (trace) {
        return trace.file.match(filesToIgnore);
      });
    });
    if (errorIsIgnorable) {
      return null;
    }
    return notice;
  });
}
export default airbrake;